import { p as proxyCustomElement, H, h, d as Host } from './p-BJEvNVLM.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";

const CosmosIconFilterList$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconFilterList extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: 'e3b3bdc928ea8c18196f0bdc6e03a9bcefe34945', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: '7ab6a584ee11b82fd561edeb439cde8f60c248ec', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: '9f3e4a95860c7a36ebd72c347f73897103c9bcfe', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M3.5 5a.5.5 0 0 0-.5.5V6a.5.5 0 0 0 .5.5h15A.5.5 0 0 0 19 6v-.5a.5.5 0 0 0-.5-.5zm7 5.25a.5.5 0 0 0-.5.5v.5a.5.5 0 0 0 .5.5h8a.5.5 0 0 0 .5-.5v-.5a.5.5 0 0 0-.5-.5zM14 16a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 .5.5v.5a.5.5 0 0 1-.5.5h-4a.5.5 0 0 1-.5-.5zm-7.25-2h2.53a.3.3 0 0 1 .21.51l-3.13 3.16a.5.5 0 0 1-.71 0l-3.14-3.16a.3.3 0 0 1 .22-.51h2.52v-3.5a.5.5 0 0 1 .5-.5h.5a.5.5 0 0 1 .5.5z", fill: "currentColor" }))));
    }
    static get style() { return cosmosIconCss; }
}, [1, "cosmos-icon-filter-list", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-filter-list"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-filter-list":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconFilterList$1);
            }
            break;
    } });
}

const CosmosIconFilterList = CosmosIconFilterList$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconFilterList, defineCustomElement };
